import { AppShell } from "@mantine/core";

import ChatWidget from "../chat-widget/chat-widget";
import LanguageSelector from "../language-selector/language-selector";
import ThemeSelector from "../theme-selector/theme-selector";
import BraouFooter from "./BraouFooter";
import BraouHeader from "./BraouHeader";
import MainContentContainer from "./MainContentContainer";

const BraouLayout: React.FC = () => {
  return (
    <AppShell header={{ height: 72 }} padding={0} withBorder={false}>
      <AppShell.Header
        style={{
          border: "none",
          background: "transparent",
        }}
      >
        <BraouHeader />
      </AppShell.Header>

      <AppShell.Main
        style={{
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MainContentContainer />
        <BraouFooter />
      </AppShell.Main>

      <LanguageSelector />
      <ThemeSelector />
      <ChatWidget />
    </AppShell>
  );
};

export default BraouLayout;
